import { z } from "zod/v4";

import {
  AnalyticsResourceListSchema,
  DatasetIdList,
} from "../../../schemas/analytics/base";
import {
  BaseTinybirdMetricsSchema,
  MetricSchema,
} from "../../../schemas/analytics/metrics";

export const TinybirdMetricsSchema = z.record(z.string(), z.any());

export type TinybirdMetricsType = z.infer<typeof TinybirdMetricsSchema>;
export const AnalyzeTinybirdResourceResponseBodySchema = z.object({
  datasetId: z.enum(DatasetIdList),
  latestRunTs: z.number(),
  metrics: z.any(),
  audienceOrder: z.any(),
  histogram: z.any(),
  kde: z.any(),
  cdf: z.any(),
});

export type AnalyzeTinybirdResourceResponseBodyType = z.infer<
  typeof AnalyzeTinybirdResourceResponseBodySchema
>;
